import React from 'react';
import PropTypes from 'prop-types';

import { Box, Typography } from '@mui/material';

import { BLACK } from '../../../../../theme/colorConstants';

const SchedulePreviewSection = ({
  patternWeeks,
  perTwoWeekCycleTotal,
  totalShiftsForJobDuration,
  translate,
  typographySx,
  sx,
}) => (
  <Box sx={{ mb: 4 }}>
    <Typography sx={typographySx.sectionHeader}>
      {translate('job.create.recurringTwoWeeks.confirm.dateAndOpenings')}
    </Typography>

    <Box sx={{ width: '100%' }}>
      {(patternWeeks || []).map((week) => (
        <Box key={`week-${week.weekNumber}`} sx={{ mb: 3 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Box sx={sx.weekPill}>
              <Typography sx={sx.weekPillText}>
                {translate('job.create.recurringTwoWeeks.confirm.weekLabel', {
                  weekNumber: week.weekNumber,
                })}
              </Typography>
            </Box>
          </Box>

          <Box sx={sx.weekCard}>
            {week.rows.length > 0 ? (
              week.rows.map((row, idx) => (
                <Box
                  key={`week-${week.weekNumber}-day-${row.dayIndex}`}
                  sx={{
                    ...sx.weekRow,
                    borderBottom:
                      idx === week.rows.length - 1 ? 'none' : '1px solid rgba(0,0,0,0.08)',
                  }}
                >
                  <Typography sx={sx.weekRowDate}>{row.dayName}</Typography>

                  <Typography sx={sx.weekRowTime}>{row.timeRange}</Typography>

                  <Typography sx={sx.weekRowOpenings}>
                    {translate('job.create.recurringTwoWeeks.confirm.openingsCount', {
                      count: row.openings,
                    })}
                  </Typography>
                </Box>
              ))
            ) : (
              <Typography sx={{ ...typographySx.text, color: BLACK[70] }}>
                {translate('job.create.recurringTwoWeeks.confirm.noShifts')}
              </Typography>
            )}

            <Box sx={sx.weekTotalRow}>
              <Typography sx={sx.weekTotalLabel}>
                {translate('job.create.recurringTwoWeeks.confirm.weekTotalLabel', {
                  weekNumber: week.weekNumber,
                })}
              </Typography>
              <Typography sx={sx.weekTotalValue}>
                {translate('job.create.recurringTwoWeeks.confirm.openingsCount', {
                  count: week.totalOpenings,
                })}
              </Typography>
            </Box>
          </Box>
        </Box>
      ))}

      <Box sx={sx.totalPositionsSummaryCard}>
        <Typography sx={sx.totalPositionsSummaryTitle}>
          {translate('job.create.recurringTwoWeeks.confirm.totalPositionsSummary.title')}
        </Typography>

        <Box sx={sx.totalPositionsSummaryRow}>
          <Box sx={sx.totalPositionsSummaryCol}>
            <Typography sx={sx.totalPositionsSummaryLabel}>
              {translate(
                'job.create.recurringTwoWeeks.confirm.totalPositionsSummary.perCycleLabel'
              )}
            </Typography>
            <Typography sx={sx.totalPositionsSummaryValue}>
              {translate('job.create.recurringTwoWeeks.confirm.openingsCount', {
                count: perTwoWeekCycleTotal,
              })}
            </Typography>
          </Box>

          <Box sx={sx.totalPositionsSummaryColRight}>
            <Typography sx={sx.totalPositionsSummaryLabel}>
              {translate('job.create.recurringTwoWeeks.confirm.jobDurationCard.label')}
            </Typography>
            <Typography sx={sx.totalPositionsSummaryValue}>
              {translate('job.create.recurringTwoWeeks.confirm.openingsCount', {
                count: totalShiftsForJobDuration,
              })}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  </Box>
);

SchedulePreviewSection.propTypes = {
  patternWeeks: PropTypes.arrayOf(
    PropTypes.shape({
      rows: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
      totalOpenings: PropTypes.number.isRequired,
      weekNumber: PropTypes.number.isRequired,
    })
  ),
  sx: PropTypes.shape({
    weekPill: PropTypes.shape({}).isRequired,
    weekPillText: PropTypes.shape({}).isRequired,
    weekCard: PropTypes.shape({}).isRequired,
    weekRow: PropTypes.shape({}).isRequired,
    weekRowDate: PropTypes.shape({}).isRequired,
    weekRowTime: PropTypes.shape({}).isRequired,
    weekRowOpenings: PropTypes.shape({}).isRequired,
    weekTotalRow: PropTypes.shape({}).isRequired,
    weekTotalLabel: PropTypes.shape({}).isRequired,
    weekTotalValue: PropTypes.shape({}).isRequired,
    totalPositionsSummaryCard: PropTypes.shape({}).isRequired,
    totalPositionsSummaryTitle: PropTypes.shape({}).isRequired,
    totalPositionsSummaryRow: PropTypes.shape({}).isRequired,
    totalPositionsSummaryCol: PropTypes.shape({}).isRequired,
    totalPositionsSummaryColRight: PropTypes.shape({}).isRequired,
    totalPositionsSummaryLabel: PropTypes.shape({}).isRequired,
    totalPositionsSummaryValue: PropTypes.shape({}).isRequired,
  }).isRequired,
  translate: PropTypes.func.isRequired,
  totalShiftsForJobDuration: PropTypes.number,
  perTwoWeekCycleTotal: PropTypes.number,
  typographySx: PropTypes.shape({
    sectionHeader: PropTypes.shape({}).isRequired,
    text: PropTypes.shape({}).isRequired,
  }).isRequired,
};

export default SchedulePreviewSection;
